import React from "react";
import{ imageDomain} from "../configC/keys"
import {
  Image,
  //Button,
} from "semantic-ui-react";
import ReactPlayer from 'react-player'

  const About =()=> {
  
  
     
    //*************** */
    return (
      <section className="padding-gr-outer bgColor-gr1 ">
      
      <div className="inner-gr bgColor-gr1 ">
        {/* heading */}
        <div className="headtitl">
          <div
            className="line-height-gr font-36B color-CornflowerBlue"
          >
           About Us <br/>
 				<span className="font-24B">A Real Estate Company</span>
          </div>
          
          <div className="devider">
           
          </div>
        </div>
{/* end heading */}
        {/* about section start */}
        <div className="flex-center direction-r2c direction-col-770">

          {/* image section */}
        <div  style={{display:'flex',flex:'40%'}}>
        <div style={{textAlign:'center',}} > 
  <img 
  src={`${imageDomain}/upload/about/about.jpg`} alt="about_img" 
  style={{textAlign:'center', maxWidth:"100%", maxHeight:"auto",padding:'0px'}} />
  </div>
  </div>
    {/* end image section */}
    <div style={{flex:'60%',padding:'20px',fontWeight:"bold"}}>
    <p className="font-24B" style={{textAlign: 'justify'}}>
30+ Years Of Experience
</p>
<p  style={{textAlign: 'justify'}}>
Gupta Realtors is a preferred and reliable real estate consultancy 
firm in Dwarka (Delhi) and Dwarka Expressway (Gurugram). 
We are committed to ethical business practices and stand for 
honesty, transparency, and professionalism in every transaction. 
As a firm, we promise to deliver excellent, hassle-free, 
and customer-focused services. Our philosophy is simple: 
<span className="font-18B color-blue"> “Our clients should settle for nothing less than the best”</span>.
</p>
<p  style={{textAlign: 'justify'}}>
Our team of subject matter experts possesses extensive knowledge 
of the real estate domain, covering sales, purchases, and rentals. 
This expertise enables us to offer the best property deals 
tailored to our client's needs. Whether you are searching for a 
residential or commercial property, our team is always ready to 
assist you with the right solutions.
</p>
<p  style={{textAlign: 'justify'}}>
With deep market insight and a client-first approach, we make the 
entire real estate process smooth, transparent, and efficient. 
Our wide range of property options ensures that every client 
finds the right fit—be it a home, office space, or investment 
opportunity. We are dedicated to guiding our clients at every 
step and helping them make informed and profitable decisions.
</p>
<p  style={{textAlign: 'justify'}}>
The group is managed and supervised by Mr. Sahil Gupta, who holds 
an MSc in Finance and Investment from the University of Nottingham 
(U.K.) He works under the guidance of his father, Mr. Subhash Gupta,
 Director of M/s Gupta Property & Developers Pvt. Ltd., who brings 
 over 30 years of experience in the real estate and construction 
 industry in India.
</p>
<p  style={{textAlign: 'justify'}}>
At Gupta Realtors, we strive to build long-term relationships based
 on trust, reliability, and customer satisfaction, making us your 
 preferred partner for all real estate needs.
</p>
  </div>

          
        </div>
        {/* about section end */}
{/* heading */}
<div className="headtitl">
          <div
            className="line-height-gr font-24B color-CornflowerBlue"
          >
          Sahil Gupta
<span style={{color: '#5079cb'}}>(CEO , MD)</span>
          </div>
          
          <div className="devider">
           
          </div>
        </div>
{/* end heading */}
         {/* sahil section start */}
         <div className="flex-center direction-r2c direction-col-770"
          style={{flexWrap:'nowrap'}}
         >

{/* image section */}
<div  className="md-col-1" style={{padding:'5px' ,display:'flex',flexDirection:'column',justifyContent:'center', alignItems:'flex-center', flex:'30%'}}>
<div >
<Image 
src={`${imageDomain}/upload/about/sahil.jpeg`} alt="CMD's Img  "
// src="/sahil.jpeg"  
style={{width:"auto", maxHeight:"500px",}} />
</div>
{/* <div className="flex-center" style={{minWidth:"350px",backgroundColor:'black'}}>

</div> */}
<div className='player-wrapper'>
            <ReactPlayer
            // Disable download button
  config={{ file: { attributes: { controlsList: 'nodownload' } } }}

  // Disable right click
  onContextMenu={e => e.preventDefault()}
  // playing={playing}
  // playing={true}
            controls = {true}
            className='react-player'
            url='https://www.youtube.com/watch?v=NCa2Kwaf2WE&autoplay=1&mute=1'
            width='100%'
            height='100%'
            />
            </div>
</div>
{/* end image section */}
<div className="md-col-2 padding-sahil"style={{alignSelf:'flex-start',flex:'40%',fontWeight:"bold"}}>

<p className="font-18B" style={{textAlign: 'justify'}}>
Sahil Gupta Post Graduated from the University of Nottingham, 
U.K. in MSC Finance and Investment in the first division in 
2011. Who has an experience of more than 15 years in the real 
estate field in Dwarka and Dwarka Expressway and is actively 
handling his father's legacy "Gupta Realtors". He is 
courteous, thorough professional, very clear and concise 
at every step of the process. He has successfully managed 
thousands of deals with his professional team of 50+ members 
since then. He is actively available for each transaction his
 company closes to cater to his clients and provide the best 
 they deserve.
</p>

</div>

{/* image section */}
<div className="md-col-3" style={{padding:'5px' ,display:'flex',flex:'30%'}}>
<Image 

onClick={() => this.handleOpenModal(photoCP1)}
src={`${imageDomain}/upload/about/certificatea.png`} alt="certificate"
// src="/certificatea.png"  
style={{width:"auto", maxHeight:"500px",padding:'5px'}} />
</div>
{/* end image section */}

</div>
{/* sahil section end */}

        {/*  */}
      </div>
   
</section>

  


   
    );
  }


export default About
